// auth-modal.js – simplified, no popup, no AJAX
// The login and register pages now use native Shopify form submission.
// This file is kept minimal for compatibility.
document.addEventListener('DOMContentLoaded', () => {
  // Nothing needed – auth pages are standalone pages now.
});
